const account = {
    saveToLocalStorage(account) {
        delete account.password;
        localStorage.setItem('account', JSON.stringify(account));
        return true;
    },
    removeCurrentUser() {
        localStorage.removeItem('account');
    },
    getIdUser() {
        let account = localStorage.getItem('account') ? JSON.parse(localStorage.getItem('account')) : false;
        if(account) {
            return {
                username: account.username,
                email: account.email,
            }
        } else {
            return false;
        }
    }
}

export default account;